import React, { useState } from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

/**
 * Dismissible warnings from lab-data API responses.
 */
const LabDataWarningsBanner = ({ warnings = [] }) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !warnings?.length) {
    return null;
  }

  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      {warnings.map((message, index) => (
        <Alert
          key={`${index}-${message}`}
          severity="warning"
          onClose={() => setDismissed(true)}
        >
          {message}
        </Alert>
      ))}
    </Stack>
  );
};

export default LabDataWarningsBanner;
